/**
 * What the documents page says once extraction was asked for a selection: how many documents
 * were scheduled, how many were left to structured ingest, how many the server left alone
 * because they are being processed already (an audio file is processed from the moment it is
 * uploaded), and how many failed. Pure.
 */
import type { ExtractResponse } from '@/services/api/cases'
import type { ExtractResults } from './types'

/** `leftToStructuredIngest`: selected files the page itself kept out of the request. */
export function toExtractResults(
  response: ExtractResponse,
  leftToStructuredIngest: number
): ExtractResults {
  return {
    scheduled: response.started,
    skipped: leftToStructuredIngest,
    alreadyProcessing: response.skipped ?? 0,
    failed: response.failed,
    errors: response.errors ?? [],
    held: response.held ?? [],
  }
}

/** How the result reads: something failed, nothing new was scheduled, or all went as asked. */
export type ExtractResultsTone = 'warning' | 'info' | 'success'

export function extractResultsTone(results: ExtractResults): ExtractResultsTone {
  if (results.failed > 0) return 'warning'
  return results.scheduled === 0 ? 'info' : 'success'
}
